import { Link } from "@mui/material";
import { Typography } from "src/components-mui/base/typography/typography";

export interface ITradernameProfileLinkProps {
    href: string;
    name: string;
    isDeleted: boolean | undefined;
}

export const WfTradernameProfileLink = ({ href, name, isDeleted }: ITradernameProfileLinkProps) => {
    return isDeleted ? (
        <Typography component="span" sx={{ fontWeight: "bold" }}>
            {name}
        </Typography>
    ) : (
        <Link href={href} underline="hover" noWrap sx={{ wordBreak: "break-all" }}>
            {name}
        </Link>
    );
};
